module.exports = __webpack_public_path__ + "static/img/digital_storage.c97611b.jpeg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/digital_storage.jpeg
// module id = DiG1
// module chunks = 7